export default {
    "apiUrl": 'https://api.smartcitymm.com/backend/',
    "mediaUrl": 'https://api.smartcitymm.com',
    // "apiUrl": 'http://localhost:8000/backend/',
    // "mediaUrl": 'http://localhost:8000',
}